import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { v4 as uuidv4 } from "uuid";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import { validDocumentTypes, validImageTypes, isAllowedFile } from "../../../../assests/extention/fileextention";

export default function FileAttachment({ selectedfiles = [], setWork_sample }) {
  const [selectedFiles, setSelectedFiles] = useState(selectedfiles);

  const handleUpload = (files) => {
    const uploadPromises = files.map((file) => {
      if (file.size > 10 * 1024 * 1024) {
        urtoast(`File size exceeds 10MB limit.`);
        return Promise.reject(new Error("File size exceeds limit."));
      }

      if (!isAllowedFile(file)) {
        urtoast("Unsupported file format. Please upload a valid file type.", 2);
        return Promise.reject(new Error("Unsupported file type."));
      }

      if (
        validImageTypes.includes(file.type) ||
        validDocumentTypes.includes(file.type)
      ) {
        const uniqueId1 = uuidv4(); // Generate a unique ID for each file
        const storageRef = ref(
          getStorage(),
          `/Category/${uniqueId1}_${file.name}`,
        );
        const uploadTask = uploadBytesResumable(storageRef, file);
        return uploadTask
          .then(async () => {
            const url = await getDownloadURL(uploadTask.snapshot.ref);
            return { file: url, fileName: file.name };
          })
          .catch((error) => {
            urtoast(`Error uploading ${file.name}: ${error.message}`);
            throw error;
          });
      } else {
        urtoast(`This file type is not supported`);
        return Promise.reject(new Error("Unsupported file type."));
      }
    });

    Promise.all(uploadPromises)
      .then((urls) => {
        const updatedFiles = [...selectedFiles, ...urls];
        setSelectedFiles(updatedFiles);
        setWork_sample((prevData) => ({
          ...prevData,
          files: updatedFiles,
        }));
      })
      .catch((error) => {
        console.error("Error uploading files: ", error);
      });
  };

  const onDrop = (acceptedFiles) => {
    handleUpload(acceptedFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const handleDeleteImage = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
    setWork_sample((prevData) => ({
      ...prevData,
      files: updatedFiles,
    }));
  };

  return (
    <div className="add-portfolio">
      <h6 className="skill-right file-attachment">
        Upload file <sup></sup> <span> (Optional)</span>
      </h6>
      <div className="col-md-12 p-0 ">
        <div className="row" style={{ rowGap: '30px' }}>
          {selectedFiles.length === 0 ? (
            <div className="col-md-5 ">
              <div className="image-container">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/file-upload.png`}
                  className="cover-img w-100"
                  alt="Certificate"
                />
                {/* <button>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                    alt=""
                  />
                </button> */}
              </div>
            </div>
          ) : (



            selectedFiles.map((item, index) => (
              <div className="col-md-4">


                <div key={index} className="image-container">
                  <DisplayFileProper item={item} />
                  {/* <DownloadButton file={item} /> */}
                  <button
                    type="button"
                    className="delete-button"
                    onClick={() => handleDeleteImage(index)}
                  >
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                      alt="Delete"
                    />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <div {...getRootProps({ className: "dropzone borderstylex" })}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the files here...</p>
        ) : (
          <p>
            Drag and drop or <span>Browse file</span>
          </p>
        )}
      </div>
      <ul className="border-ul">
        <li>Images (JPG, PNG, JPEG up to 10MB)</li>
        <li>Documents (PDF, DOC, DOCX, PPT, PPTX, ZIP, XLS, XLSX up to 10MB)</li>
      </ul>
    </div>
  );
}
